import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=7e2a07b4&"
import script from "./VideoGallery.vue?vue&type=script&lang=ts&"
export * from "./VideoGallery.vue?vue&type=script&lang=ts&"
import style0 from "./VideoGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports